import _ from 'lodash';
import PensionAccounts from '@/app/modules/toolkit/pension/establishment/modules/workflow/components/pension-accounts/pension-accounts.vue';
import ReversionaryBeneficiary from '@/app/modules/toolkit/pension/establishment/modules/workflow/components/reversionary-beneficiary/reversionary-beneficiary.vue';
import PensionSegregation from '@/app/modules/toolkit/pension/establishment/modules/workflow/components/pension-segregation/pension-segregation.vue';
import PensionFinalChecks from '@/app/modules/toolkit/pension/establishment/modules/workflow/components/pension-final-checks/pension-final-checks.vue';
import PensionSchedule from '@/app/modules/toolkit/pension/establishment/modules/workflow/components/pension-schedule/pension-schedule.vue';

export default {
  name: 'pension-establishment-container',
  components: {
    PensionAccounts,
    ReversionaryBeneficiary,
    PensionSegregation,
    PensionFinalChecks,
    PensionSchedule,
  },
  data() {
    return {
      isPensionFlow: false,
      currentPensionStep: 0,
      pensionSetupSteps: [],
    };
  },
  watch: {
    isStepOnePensionForm: {
      handler(val) {
        if (val) {
          this.pensionSetupSteps = [
            {
              component: 'reversionary-beneficiary',
            },
            {
              component: 'pension-segregation',
            },
            {
              component: 'pension-final-checks',
            },
          ];
        } else {
          this.pensionSetupSteps = [
            {
              component: 'pension-schedule',
            },
            {
              component: 'reversionary-beneficiary',
            },
            {
              component: 'pension-segregation',
            },
            {
              component: 'pension-final-checks',
            },
          ];
        }
      },
      immediate: true,
    },
    isPensionFlow: {
      handler(val) {
        this.$emit('disableStepper', val);
      },
      immediate: true,
    },
  },
  computed: {
    isStepOnePensionForm() {
      const needsAmount = [
        'The balance of the pensioner\'s accumulation account less a fixed amount',
        'A fixed amount',
      ];
      const { part, howMuch } = this.pensionKitEstablishment.data.setup;
      if (part === 'PART_1' && !needsAmount.some(value => value === howMuch)) {
        return true;
      }
      return false;
    },
    pensionKitEstablishment() {
      return this.$store.getters['toolkit/getItem'];
    },
    getItem() {
      return this.$store.getters['toolkit/getItem'].data;
    },
    pensions() {
      return this.getItem.pensions;
    },
    activePension() {
      return this.getItem.activePension;
    },
    currentPensionComponent() {
      // eslint-disable-next-line max-len
      return this.currentPensionStep > -1 && this.currentPensionStep <= this.pensionSetupSteps.length - 1
        ? this.pensionSetupSteps[this.currentPensionStep].component
        : false;
    },
  },
  methods: {
    async nextPensionStep() {
      if (this.currentPensionStep < this.pensionSetupSteps.length - 1) {
        this.currentPensionStep = this.currentPensionStep + 1;
      } else if (this.currentPensionStep === (this.pensionSetupSteps.length - 1)) {
        if (this.pensions[this.activePension].status === 'NEEDS_REVIEW') {
          const pensions = _.cloneDeep(this.pensions);
          pensions[this.activePension].status = 'IN_PROGRESS';
          await this.$store.dispatch('toolkit/updateItemKey', { data: { pensions } });
        }
        // eslint-disable-next-line no-unused-vars
        await this.$store.dispatch('toolkit/saveItem').catch((err) => {});
        this.currentPensionStep = 0;
        this.isPensionFlow = false;
      }
    },
    backPensionStep() {
      if (this.currentPensionStep > 0) {
        this.currentPensionStep = this.currentPensionStep - 1;
      } else if (this.currentPensionStep === 0) {
        this.isPensionFlow = false;
      }
    },
    handleBackStep() {
      this.$emit('backStep');
    },
    handleNextStep() {
      this.$emit('nextStep');
    },
  },
};
